import React from "react";

export const products_url = "https://fakestoreapi.com/products";
export const single_product_url = "https://fakestoreapi.com/products/";
export const category_url="https://fakestoreapi.com/products/category/";